export const PROFILE_NAME_MAX_LENGTH = {
  DEFAULT: 25,
  CUSTOM: 24,
};
